// TODO: данный тип будет в @litres/api генерироваться автоматически
type APIPath = "foundation" | "advertising";

type APITimeoutsConfig = Record<APIPath, { client: number; ssr: number }>;

const API_CLIENT_DEFAULT_TIMEOUT = 40000;
const FOUNDATION_API_SSR_PRODUCTION_TIMEOUT = 5000;
const FOUNDATION_API_SSR_DEVELOPMENT_TIMEOUT =
  FOUNDATION_API_SSR_PRODUCTION_TIMEOUT * 100; // при разработке увеличиваем время ожидания, так как запрос идет с локальной машины на удаленный сервер, а также для удобного использования точек останова.

const FOUNDATION_API_REQUESTS_WITH_INCREASED_TIMEOUT = [
  "/api/purchase-sets", // TODO: Удалить после выполнения https://jira.mybook.tech/browse/PAY-1841
];

const apiTimeoutsConfig: APITimeoutsConfig = {
  foundation: {
    client: API_CLIENT_DEFAULT_TIMEOUT,
    ssr:
      process.env.NODE_ENV === "development"
        ? FOUNDATION_API_SSR_DEVELOPMENT_TIMEOUT
        : FOUNDATION_API_SSR_PRODUCTION_TIMEOUT,
  },
  advertising: {
    client: API_CLIENT_DEFAULT_TIMEOUT,
    ssr: 800,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const _getAPITimeout =
  (config: APITimeoutsConfig) =>
  (apiPath: APIPath, isClient: boolean, url: string) => {
    if (
      !isClient &&
      FOUNDATION_API_REQUESTS_WITH_INCREASED_TIMEOUT.some(requestUrl =>
        url.includes(requestUrl)
      )
    ) {
      return FOUNDATION_API_SSR_PRODUCTION_TIMEOUT * 2;
    }

    return config[apiPath][isClient ? "client" : "ssr"];
  };

export const getAPITimeout = _getAPITimeout(apiTimeoutsConfig);
